import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, tap } from 'rxjs';
import { PaginatedRepository } from '../../../services/pagination/paginated.repository';
import { UnpaidInvoiceReport } from '../../../interfaces/reports/unpaid-invoice-report';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../../reg-hub-common-config';


@Injectable({
  providedIn: 'root'
})
export class UnpaidInvoicesReportRepositoryService extends PaginatedRepository<UnpaidInvoiceReport> {

    protected override _baseLink: string;

  constructor(
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig,
        http: HttpClient,
        messageService: ToastrService) {
        super(http, messageService);
        this._baseLink = `${config.rootUrl}/Reports/UnpaidInvoices`;
  }
}
